const WEBAPP_BASE_URL_PRODUCTION = 'https://embedded.cardless.com';
const WEBAPP_BASE_URL_STAGING = 'https://embedded.cardless-staging.com';
export { WEBAPP_BASE_URL_PRODUCTION, WEBAPP_BASE_URL_STAGING };
